import { render, staticRenderFns } from "./DocumentsSetting.vue?vue&type=template&id=5a15b757&"
import script from "./DocumentsSetting.vue?vue&type=script&lang=js&"
export * from "./DocumentsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports